import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import toastr from "toastr";
import Indentification from "../elements/Indentification";
import { allowedImageExtensions } from "../../helpers";

const ImageUpload = ({
  src,
  initial,
  alt,
  onChange = () => {},
  onRemove = () => {},
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [fileInfo, setFileInfo] = useState(null);
  const fileInputRef = useRef();

  function imageUploadHandler(e) {
    const file = e.target.files[0];
    if (!file) return;

    const type = file?.type.split("/")[0];
    const ext = file?.type.split("/")[1]?.toLowerCase();

    if (type !== "image") {
      toastr.error("Only image files are allowed.");
      return;
    }

    if (!allowedImageExtensions().includes(ext)) {
      toastr.error("Please upload a valid image file (JPG, PNG, WebP).");
      return;
    }

    setFileInfo({
      name: file.name,
      size: (file.size / 1024).toFixed(1),
      type: file.type,
    });

    onChange(file);
  }

  return (
    <div className="">
      <div className="flex justify-center items-center gap-4">
        <label
          className="h-48 w-48 min-w-20 rounded-full border border-slate-300 overflow-hidden flex flex-col relative cursor-pointer group"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="h-full w-full">
            <Indentification
              image={src}
              size="max"
              initialClass="!text-[50px] !bg-transparent !text-slate-700"
              className=""
              initial={initial}
              alt={alt}
            />
          </div>

          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: isHovered ? "0%" : "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            className="bg-black/30 absolute bottom-0 left-0 w-full h-6 flex items-center justify-center text-white text-xs"
          >
            <i className="fa-fw fa-regular fa-camera text-xs"></i>
          </motion.div>

          {/* {src && isHovered && (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setFileInfo(null);
                onRemove();
              }}
              className="absolute top-1 right-1 z-10 bg-black/60 text-white rounded-full p-1 hover:bg-red-600"
              title="Remove image"
            >
              <i className="fa-regular fa-trash"></i>
            </button>
          )} */}

          <input
            type="file"
            accept="image/*"
            onChange={imageUploadHandler}
            ref={fileInputRef}
            className="hidden"
          />
        </label>
      </div>
      <div
        className="flex justify-center items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-100 hover:border-gray-400 transition-colors cursor-pointer mt-3"
        onClick={() => fileInputRef.current?.click()}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            fileInputRef.current?.click();
          }
        }}
      >
        <i className="fa-solid fa-upload text-base"></i>
        <span>Upload Image</span>
      </div>
      {fileInfo && (
        <div className="mt-2 text-xs text-slate-500 ml-1">
          <div>
            <strong>Name:</strong> {fileInfo.name}
          </div>
          <div>
            <strong>Size:</strong> {fileInfo.size} KB
          </div>
          <div>
            <strong>Type:</strong> {fileInfo.type}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
